/**
 * Pure helpers for login form validation and error message classification.
 * No React or router imports — safe to unit test without a DOM environment.
 */

export function isLoginFormValid(email, password) {
  return email.trim().length > 0 && password.trim().length > 0;
}

export function getLoginErrorMessage(err) {
  if (!err.response) {
    return "Unable to reach the server. Please check your connection and try again.";
  }
  if (err.response.status === 429) {
    return err.response.data?.detail || "Too many login attempts. Please wait before trying again.";
  }
  if (err.response.status >= 500) {
    return "A server error occurred. Please try again in a moment.";
  }
  return err.response.data?.detail || "Invalid credentials";
}
